var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktopWide = function SvgDesktopWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 28 28",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.213 23.917v-1.324h2.463v-2.76H4.6q-.686 0-1.184-.498a1.62 1.62 0 0 1-.498-1.184V5.766q0-.686.498-1.185a1.62 1.62 0 0 1 1.184-.498h18.802q.686 0 1.184.498.498.499.498 1.185V18.15q0 .686-.498 1.184a1.62 1.62 0 0 1-1.184.498h-8.078v2.76h2.464v1.324zM4.599 18.51h18.802q.135 0 .246-.113a.34.34 0 0 0 .112-.246V5.766a.34.34 0 0 0-.112-.247.34.34 0 0 0-.246-.112H4.599a.34.34 0 0 0-.247.112.34.34 0 0 0-.112.247V18.15q0 .135.112.246a.34.34 0 0 0 .247.113"
  })));
};
export default SvgDesktopWide;